import type { CardsFulfillmentStatus } from '@dock/types-dock-partner';

import { ChipColors } from '../../../common';

export const physicalCardStatusColorMap: Record<CardsFulfillmentStatus, ChipColors> = {
    ISSUED: ChipColors.success,
    ORDERED: ChipColors.success,
};
